module.exports = __webpack_public_path__ + "static/media/b3-阿婆茶楼.17fa0840.png";